import { Authentication } from '@/rbac';
import Profile from '@/routes/arc/profile/Profile.tsx';

export const Route = createFileRoute({
  component: ProfilePage,
});

function ProfilePage() {
  return (
    <div className={'fit-col p-2.5'}>
      <Authentication require={['arc:profile']} failMode={'empty'}>
        <Profile
          key={'scheme-page'}
          hasBack
          showEdit={true}
          showSwitch={false}
        />
      </Authentication>
    </div>
  );
}
